import { atom } from 'jotai'

import type { Runner } from '~shared/types'
import { RunnerState } from '~shared/types'

const _runnerAtom = atom<Runner | null>(null)

export const runnerAtom = atom(
  (get) => {
    const runner = get(_runnerAtom)

    // If new runner or null, return actual runner
    if (!runner || runner.originalCues) return runner

    return null
  },
  (_, set, runner: Runner | null) => {
    set(_runnerAtom, runner)
  },
)

export const runnerStateAtom = atom((get) => {
  const runner = get(runnerAtom)

  if (!runner) return RunnerState.PRESHOW

  if (!runner.timesnap?.cueId) return RunnerState.ENDED

  return RunnerState.ONAIR
})

export const isRunningAtom = atom((get) => {
  const runner = get(runnerAtom)

  return runner?.timesnap?.running
})

//
// Selector atoms for runner document
//

/** Id of the cue on air, or null before and after the show. */
export const activeCueIdAtom = atom(
  (get) => get(runnerAtom)?.timesnap?.cueId ?? null,
)

/** Id of the cue the runner has queued as next. */
export const runnerNextCueIdAtom = atom(
  (get) => get(runnerAtom)?.nextCueId ?? null,
)

/** Id of the runner document, or null before a runner exists. */
export const runnerIdAtom = atom((get) => get(runnerAtom)?.id ?? null)

/** Wall-clock ms when the runner was last paused. */
export const runnerLastStopAtom = atom(
  (get) => get(runnerAtom)?.timesnap.lastStop,
)

//
// Time Sync
//
export const timeOffsetAtom = atom<number>(0) // Difference between server and client time

// Getter atom that provides server-adjusted current time
export const getNowAtom = atom((get) => {
  const offset = get(timeOffsetAtom)

  return () => Date.now() + offset
})

//
// Ping
//
export const pingAtom = atom<number>(0)
